import { PAGE_WRAPPER } from '@efdigital/ll-xceed-v2/utils/layout';
import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { pageTitle } from 'ember-page-title';

interface CoacheeErrorSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Coachees"}}

  <div class={{PAGE_WRAPPER}}>
    <div class="alert alert-warning">
      <p class="mb-0">
        We could not find that coachee. They may no longer be working with you.
      </p>
    </div>
    <LinkTo @route="coaching.coach.coachees" class="btn btn-outline-primary">
      Back to my coachees
    </LinkTo>
  </div>
</template> satisfies TOC<CoacheeErrorSignature>;
